namespace $.$$ {
	/** A host adapter only: application code stays in the domain catalogue. */
	export class $shm_hitalama_components_embed extends $.$shm_hitalama_components_embed {
		@ $mol_mem
		loader() { return new this.$.$shm_hitalama_map_component }
		@ $mol_mem
		instance(): $mol_view {
			const Class = this.loader().component_class( this.fqn() )
			const instance = new Class()
			if( !( instance instanceof this.$.$mol_view ) ) throw new Error( 'Встроенный модуль должен возвращать представление.' )
			return instance
		}
	}
}
